export default __webpack_public_path__ + "static/media/eye.e1fc05be.svg";